import { Typography } from '@mui/material';
import { Column, TableState, usePagination, useRowSelect, useSortBy, useTable } from 'react-table';
import { NameChangeReviewGridItem } from 'shared/types';
import { customerNameChangeTableColumns } from './columns/name-change-review-table-columns';
import { NameChangeApprovalWorkflowTableState } from 'shared/contexts/name-change-approval-workflow-filter-context';

const defaultColumnNameChange: Partial<Column<NameChangeReviewGridItem>> = {
  Filter: () => null,
  Cell: ({ value = '' }) => <Typography variant='body2'>{value}</Typography>,
  disableFilters: true,
  width: 150,
  minWidth: 150,
  maxWidth: 150,
  align: 'inherit',
};

const getRowIdNameChange = (row: NameChangeReviewGridItem) => row.id;

export function useNameChangeReviewTableInstance(
  data: NameChangeReviewGridItem[],
  totalCount: number,
  initialState: TableState<NameChangeApprovalWorkflowTableState>
) {
  return useTable<NameChangeReviewGridItem>(
    {
      columns: customerNameChangeTableColumns,
      data,
      initialState,
      pageCount: totalCount,
      manualSortBy: true,
      manualPagination: true,
      manualFilters: true,
      defaultColumnNameChange,
      getRowIdNameChange,
      autoResetFilters: false,
      autoResetPage: false,
    },
    useSortBy,
    usePagination,
    useRowSelect
  );
}
